import PageStyle from "@/styles/components/request-for-more/_index.module.scss";
import Button from "@/components/button";
import parse from 'html-react-parser';

export function PrivacyPolicyDetails({setPrivacyPolicy, content}) {

  return (
    <div className={`${PageStyle.SetupPopup}`}>
      <div className={`${PageStyle.SetupPopup__inner}  ${PageStyle.SetupPopup__ModalCenter} Innerheightthresoldmargin InnerPrivacyHeight`}>
        <div className={PageStyle.OtpBacksection2}>
          <div className={PageStyle.Otpback}>
            <Button
              buttonstyle={PageStyle.nobgbutton}
              type="button"
              onClick={()=> {setPrivacyPolicy(false)}}
            >
              Close
            </Button>
          </div>
        </div>
        <div className={`${PageStyle.SetupPopup__Content} DisplayInline`}>
          <h1>Privacy Policy </h1>

      
          {/* <p className={PageStyle.SetupPopup__Details}> We use Candidly, an online application provider and applicant tracking system (ATS) for assisting with our recruitment processes. Candidly collect, use, store, and share Aggregated Data such as statistical or demographic data. Aggregated Data could be derived from your personal data but is not considered personal data in law as this data is anonymised/ pseudonymised and will not directly or indirectly reveal your identity. For example, we may aggregate your Professional Data to develop analytics with respect to a specific platform feature or component. However, if we combine or connect Aggregated Data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data which will be used in accordance with this privacy policy.
           We use Candidly, an online application provider and applicant tracking system (ATS) for assisting with our recruitment processes. Candidly collect, use, store, and share Aggregated Data such as statistical or demographic data. Aggregated Data could be derived from your personal data but is not considered personal data in law as this data is anonymised/ pseudonymised and will not directly or indirectly reveal your identity. For example, we may aggregate your Professional Data to develop analytics with respect to a specific platform feature or component. However, if we combine or connect Aggregated Data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data which will be used in accordance with this privacy policy.
          </p> */}
         <div className={PageStyle.SetupPopup__PrivacyPolicyDetails}>
         {parse(content)}
         </div>
  
        <div className={PageStyle.SetupPopup__AutommationFooter}>
        <div className={PageStyle.SetupPopup__SubmitSectionAutomation}>
        <Button buttonstyle={PageStyle.primarybtn} type="button" onClick={()=> {setPrivacyPolicy(false)}}>
        Ok
          </Button>
          
          </div>
        </div>
        </div>

      </div>
    </div>
  )

}
